import { api } from '../api';

// All responses are ApiResponse-wrapped — peel one layer.
const unwrap = (r) => r?.data?.data ?? r?.data ?? r;

export default {
  /** Most recent unread alerts (defaults to 50). */
  list:           (params)  => api.get('/v1/alerts', { params }).then(r => unwrap(r)),

  /** Bell badge count. */
  unreadCount:    ()        => api.get('/v1/alerts/unread-count')
                                  .then(r => Number(unwrap(r)?.count ?? 0)),

  /** Lead UUIDs that should show the per-lead red dot. */
  unreadLeadIds:  ()        => api.get('/v1/alerts/unread-lead-ids').then(r => unwrap(r) || []),

  /** Mark one alert read. */
  read:           (id)      => api.post(`/v1/alerts/${id}/read`).then(r => unwrap(r)),

  /** Mark every alert read (used by "Mark all as read" in the dropdown). */
  readAll:        ()        => api.post('/v1/alerts/read-all').then(r => unwrap(r)),

  /** Mark all alerts for a single lead read (call on Lead Detail open). */
  readAllForLead: (leadId)  => api.post(`/v1/alerts/leads/${leadId}/read-all`).then(r => unwrap(r)),
};
